import { render, staticRenderFns } from "./ApplicantDetail.vue?vue&type=template&id=67d1845c&scoped=true"
import script from "./ApplicantDetail.vue?vue&type=script&lang=js"
export * from "./ApplicantDetail.vue?vue&type=script&lang=js"
import style0 from "./ApplicantDetail.vue?vue&type=style&index=0&id=67d1845c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d1845c",
  null
  
)

export default component.exports